import {Component, OnInit, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router, NavigationExtras} from '@angular/router';
import {
    PlaylistService,
    UserService,
    RadioService,
    ScrollService,
    ScrollParams,
    SearchService,
    BasicSearchParams,
    AuthService,
    SongsService
} from '../api/';
import {CreatePlaylistComponent} from './create-playlist/create-playlist.component';
import * as _ from 'lodash';
import {MdDialog, MdDialogRef} from '@angular/material';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {PlayerService} from '../player/services/player.service';
import {Helper} from '../helper';

@Component({
    selector: 'playlists',
    templateUrl: './playlists.component.html',
    styleUrls: ['./playlists.component.css']
})
export class PlaylistsComponent implements OnInit, OnDestroy {
    public playlists: any[] = [];
    private title: string = '';
    private type: string = 'P';
    private searchPlaceholder = 'Search ';
    private scrollParams = new ScrollParams();
    private searchTerm: string = '';
    private lastTerm: string = '';
    private scrollSubscriber = null;
    private loading: boolean = true;
    dialogRef: MdDialogRef<CreatePlaylistComponent>;
    private totalRecords: number = 0; // for search see all count
    private dragEnabled = false;
    private helper = new Helper();
    itsId: any = '';
    private viewAsList = 1;
    private limit: number = 20;
    private loadMore: boolean = true;
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;
    // to manage the multiple calls
    enableScrollForPlaylist = true;
    private sortedColumn = null;
    private columnArr = [
        {title: 'P', key: 'album', type: 'image', width: '120px', isSortable: true, responsiveIndex: 'all'},
        {
            title: 'name',
            key: 'name',
            type: 'anchor',
            width: '220px',
            textStyle: ['playlist-name'],
            responsiveIndex: 'gt-md'
        },
        {
            title: 'Description',
            key: 'description',
            type: 'text',
            width: '350px',
            textStyle: ['my-music-name'],
            responsiveIndex: 'all'
        },
        {
            title: 'Created By',
            key: 'created_by',
            type: 'text',
            width: '',
            responsiveIndex: 'gt-md',
            textStyle: ['my-music-artist']
        },
    ];
    enableElasticSearch: boolean = false;
    playlistData: any;
    localStoragePlaylists: any;

    constructor(private playlistService: PlaylistService, private playerService: PlayerService, private cdRef: ChangeDetectorRef, private router: Router,
    public dialog: MdDialog, private route: ActivatedRoute, private userService: UserService, private authService: AuthService, private radioService: RadioService,
    private scrollService: ScrollService, private searchService: SearchService, private songService: SongsService) {
        window.addEventListener('online', () => {this.onlineOffline1 = true;
            this.playlistService.getCall().toPromise().then((res) => {
            }).catch((err) => {
                this.onlineOffline1 = false;
                this.blockUI.stop();
            });
        });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
        if(this.route.snapshot.data['title']) {
            this.title = this.route.snapshot.data['title'];
            this.type = this.route.snapshot.data['type'];
            this.searchPlaceholder += this.title;
            if(this.route.snapshot.data['id']) {
                this.itsId = this.route.snapshot.data['id'];
            }
        }
        this.route.queryParams.subscribe((queryParams: any) => {
            if(typeof queryParams.q !== 'undefined') {
                this.searchTerm = queryParams.q;
            }
        });
        this.route.params.subscribe((params) => {
            if (params['PlaylistSlug']) {
                this.refreshPlaylist();
            }
        });
        if (this.authService.isUserLoggedIn()) {
            if(this.onlineOffline1) {
                this.userService.getUserBasicInfo().subscribe((user) => {
                    if (user.screenname === 'weget') {
                        this.dragEnabled = true;
                    }
                });
            }
        }
        // to update the data of playlist without refresh
        this.playlistService.isPlaylistUpdated.subscribe(res=> {
            if(res == true) {
                this.refreshPlaylist();
            }
        });
    }

    ngOnInit() {
        // get playlists from local storage
        this.localStoragePlaylists = JSON.parse(localStorage.getItem("playlistDetail"));
        if(!this.localStoragePlaylists) {
            this.localStoragePlaylists = [];
        }
        if(screen.width < 768) {
            this.columnArr = [
                {title: 'P', key: 'album', type: 'image', width: '120px', isSortable: true, responsiveIndex: 'all'},
                {
                    title: 'name',
                    key: 'name',
                    type: 'anchor',
                    width: '220px',
                    textStyle: ['playlist-name'],
                    responsiveIndex: 'gt-md'
                },
                {
                    title: 'Description',
                    key: 'description',
                    type: 'text',
                    width: '350px',
                    textStyle: ['my-music-name'],
                    responsiveIndex: 'all'
                },
                {
                    title: 'Created By',
                    key: 'created_by',
                    type: 'text',
                    width: '',
                    responsiveIndex: 'sm',
                    textStyle: ['my-music-artist']
                },
            ];
        }
        if(localStorage.getItem("viewAsList") == "1") {
            this.viewAsList = 1;
        }
        if(localStorage.getItem("viewAsList") == "2") {
            this.viewAsList = 2;
        }
        if(localStorage.getItem("viewAsList") == "3") {
            this.viewAsList = 3;
        }

        if(this.onlineOffline1) {
            if (this.type === 'R' || this.type === 'MR') {
                localStorage.setItem("radio", '1');
                localStorage.setItem("response", '1');
                setInterval(() => {
                    if (localStorage.getItem("radio") == "1" && localStorage.getItem("response") == "1") {
                        this.playerService.checkRadio();
                    }
                }, 2500);
            } else {
                localStorage.setItem("radio", '0');
            }
        }
        this.getPlaylists();
        if(this.viewAsList != 3) {
            this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getPlaylists());
        }
    }

    sortColumn(event, type) {
        this.sortedColumn = event;
        this.scrollParams = new ScrollParams();
        this.playlists = new Array<any>();
        this.getPlaylists();
    }

    getPlaylists() {
        this.loading = true;
        this.scrollService.toggleProgressBar(true);
        if (this.lastTerm !== this.searchTerm) {
            this.resetScrollParams();
            this.lastTerm = this.searchTerm;
            this.playlists = new Array<any>();
        }
        if (this.type === 'P') {
            if (this.loadMore)
                this.blockUI.start('Loading, please wait...');

            this.getMP();
        } else if (this.type === 'MR') {
            if (this.loadMore)
                this.blockUI.start('Loading, please wait...');

            this.getMR();
        } else if (this.type === 'search') {
            if (this.loadMore)
                this.blockUI.start('Loading, please wait...');
            this.getSearch();
        } else {
            if (this.loadMore)
                this.blockUI.start('Loading, please wait...');

            this.playLists();
        }
        if (!this.onlineOffline1) {
            this.blockUI.stop();
            this.loading = false;
        }
    }

    deleteLocal() {
        localStorage.removeItem(this.type);
        this.playlists = new Array<any>();
        this.scrollParams.page = 1;
        this.getPlaylists();
    }

    getMP() {
        if(this.localStore(this.type)) {
            if(this.onlineOffline1 == false){
              this.blockUI.stop();
              this.scrollService.toggleProgressBar(false);
              this.loading = false;
              return ;
            }

            this.playlistService.getPlaylists(this.type, this.scrollParams.page, this.sortedColumn, this.limit, true, this.searchTerm).toPromise().then((res) => {
                if(res.playlists.length <= 0 && this.searchTerm == '') {
                    this.loadMore = false;
                }
                if(res.playlists.length > 0) {
                    this.loadMore = true;
                    this.totalRecords = res.totalplaylists;
                    res.playlists.forEach((arrayItem) => {
                        this.checkLocalStorage(arrayItem);
                        var res = arrayItem.created_by.split("|");
                        arrayItem.created_by = res[0];
                        this.playlists.push(arrayItem);
                    });
                    this.scrollParams.page++;
                    this.playlists = _.uniqBy(this.playlists, 'id');
                    this.setLocalStore(this.type);
                    if(this.scrollParams.page<4){
                        this.getMP();
                    }
                }
                if(res.totalplaylists < 20) {
                    this.totalRecords = this.playlists.length;
                }
                this.blockUI.stop();
                this.scrollService.toggleProgressBar(false);
                this.loading = false;
                this.cdRef.detectChanges();
            }).catch((err) => {
                this.blockUI.stop();
                this.scrollService.toggleProgressBar(false);
                this.loading = false;
            });
        }
    }

    getMR() {
        if (this.localStore(this.type)) {
            if(this.onlineOffline1 == false)
                return ;
            this.radioService.getMyRadios(this.searchTerm, this.sortedColumn,this.limit,this.scrollParams.page).toPromise().then((res) => {
                if (res.playlists.length <= 0 && this.searchTerm == '') {
                    this.loadMore = false;
                }
                if (res.playlists.length > 0) {
                    this.loadMore = true;
                    this.playlists = res.playlists;
                    this.totalRecords = res.totalplaylists;
                    this.scrollParams.page++;
                    this.playlists = _.uniqBy(this.playlists, 'id');
                    this.setLocalStore(this.type);
                    if(this.scrollParams.page<4){
                        this.getMR();
                    }
                }
                if(res.totalplaylists < 20){
                    this.totalRecords = this.playlists.length;
                }
                this.blockUI.stop();
                this.loading = false;
            }).catch((err) => {
                this.blockUI.stop();
                this.scrollService.toggleProgressBar(false);
                this.loading = false;
            });;
        }
    }

    getSearch() {
        let params = new BasicSearchParams(false, false, false, true);
        if(this.onlineOffline1 == false)
            return ;

        let quickSearch:string = "no";
        this.songService.getPlaylistfromdb(this.searchTerm, quickSearch, this.scrollParams.page).subscribe((res) => {
            if(res['playlists']) {
                this.playlistData = res['playlists'];
                this.totalRecords = res['totalCount'];
                if(!res['playlists'] && this.enableElasticSearch) {
                    this.searchService.getSearchResults(this.searchTerm, params, this.scrollParams).then((res: any) => {
                        this.totalRecords = res.total;
                        if (res.total > 0) {
                            if (res.data.playlist.length > 0) {
                                this.loadMore = true;
                                res.data.playlist.forEach((arrayItem) => {
                                    this.checkLocalStorage(arrayItem);
                                    arrayItem._source._type = "playlist";
                                    var res = arrayItem.created_by.split("|");
                                    arrayItem.created_by = res[0];
                                    this.playlists.push(arrayItem._source);
                                });
                                this.scrollParams.page++;
                                this.playlists = _.uniqBy(this.playlists, 'id');
                            }
                        }
                        this.blockUI.stop();
                        this.scrollService.toggleProgressBar(false);
                        this.loading = false;
                        this.cdRef.detectChanges();
                    }).catch((err) => {
                        this.blockUI.stop();
                        this.scrollService.toggleProgressBar(false);
                        this.loading = false;
                    });
                }
                this.playlists = [].concat(this.playlists, this.playlistData)
                this.playlists = _.uniqBy(this.playlists, 'id');
                this.loading = false;
                if(res['playlists'].length >= 30) {
                    this.scrollParams.page++;
                }
                this.blockUI.stop();
            }
        });
    }

    playLists() {
        if(this.itsId == "id") {
            this.limit = 1;
            var btn = document.getElementById("123");
            btn.click();
        }
        if(this.localStore(this.type)) {
            if(this.onlineOffline1 == false){
              this.blockUI.stop();
              this.scrollService.toggleProgressBar(false);
              this.loading = false;
              return ;
            }
            if(this.enableScrollForPlaylist) {
                this.enableScrollForPlaylist = false;
                this.playlistService.getPlaylists(this.type, this.scrollParams.page, this.sortedColumn, this.limit, false, this.searchTerm).toPromise().then((res) => {
                    if (res.playlists.length <= 0 && this.searchTerm == '') {
                        this.loadMore = false;
                    }
                    if (res.playlists.length > 0) {
                        this.loadMore = true;
                        this.totalRecords = res.totalplaylists;
                        res.playlists.forEach((arrayItem) => {
                            this.checkLocalStorage(arrayItem);
                            var res = arrayItem.created_by.split("|");
                            arrayItem.created_by = res[0];
                            this.playlists.push(arrayItem);
                        });
                        this.scrollParams.page++;
                        this.playlists = _.uniqBy(this.playlists, 'id');
                        console.log("I am type => "+this.type);
                        if(this.type == "MS"){
                            //MONTHLY FEATURE
                            let monthly = this.playlists.filter(item => item.name.indexOf('MONTHLY FEATURE') !== -1);
                            //COMPANY SPOTLIGHT
                            let company = this.playlists.filter(item => item.name.indexOf('COMPANY SPOTLIGHT') !== -1);
                            //ARTIST SHOWCASE
                            let artists = this.playlists.filter(item => item.name.indexOf('ARTIST SHOWCASE') !== -1);
                            //SUBMISSION
                            let submissions = this.playlists.filter(item => item.name.indexOf('SUBMISSION') !== -1);

                            this.playlists = [...monthly, ...company, ...artists, ...submissions];
                        }
                        this.setLocalStore(this.type);
                        if(this.scrollParams.page < 4) {
                            this.playLists()
                        }
                        this.enableScrollForPlaylist = true;
                    } else if(res.length == 0 || res.length < 20) {
                        this.enableScrollForPlaylist = false;
                    }
                    if(res.totalplaylists < 20) {
                        this.totalRecords = this.playlists.length;
                    }
                    this.blockUI.stop();
                    this.scrollService.toggleProgressBar(false);
                    this.loading = false;
                    this.cdRef.detectChanges();
                }).catch((err) => {
                    this.blockUI.stop();
                    this.scrollService.toggleProgressBar(false);
                    this.loading = false;
                });
            }
        }
    }

    localStore($type) {
        if(this.onlineOffline1) {
            return true;
        }
        if($type=="R") {
            return true;
        }
        if (this.searchTerm != '') {
            return true;
        }
        if (this.helper.localTimeCheck(this.onlineOffline1)) {
            return true;
        }
        if(this.scrollParams.page >3){
            return true;
        }
        let playlists = JSON.parse(localStorage.getItem($type));
        if(JSON.parse(localStorage.getItem($type + "records"))){
            this.totalRecords = JSON.parse(localStorage.getItem($type + "records"));
        }
        if (playlists != null && playlists.length > 0) {
            this.scrollParams.page = Math.ceil(playlists.length / this.limit);
            this.scrollParams.page++;
            this.playlistService.getCall().toPromise().then((res) => {
                this.playlists = playlists;
                this.blockUI.stop();
            }).catch((err) => {
                this.playlists = playlists;
                this.blockUI.stop();
            });
            if(playlists.length < 30) {
                return true;
            }
            return false
        } else {
            return true;
        }
    }

    setLocalStore($type) {
        if (this.searchTerm == '')
            this.helper.setLocalStore($type, this.playlists);
        localStorage.setItem($type + "records", JSON.stringify(this.totalRecords));
    }

    handleSearch(event) {
        this.enableScrollForPlaylist = true;
        this.searchTerm = event.searchTerm;
        let navigationExtras: NavigationExtras = {
            relativeTo: this.route,
            queryParams: {'q': this.searchTerm},
        };
        this.getPlaylists();
        this.router.navigate([], navigationExtras);
    }

    createPlaylist() {
        this.dialogRef = this.dialog.open(CreatePlaylistComponent, {disableClose: false});
        this.dialogRef.afterClosed().subscribe((res) => {
            this.refreshPlaylist();
        });
    }

    private dropSuccess(args) {
        let newOrder = [];
        let i = 0;
        this.playlists.forEach((arrayItem) => {
            let playlist: any = {};
            playlist.id = arrayItem.id;
            playlist.sort = i;
            i++;
            newOrder.push(playlist);
        });
        this.playlistService.setNewOrder(newOrder).subscribe((res) => {
        });
    }

    refreshPlaylist() {
        this.scrollParams = new ScrollParams();
        this.playlists = new Array<any>();
        this.getPlaylists();
    }

    refreshList() {
        this.getPlaylists();
    }

    deleteItem(event) {
        _.remove(this.playlists, function (playlist) {
            return playlist.id === event.id;
        });
    }

    resetScrollParams() {
        this.scrollParams = new ScrollParams();
    }

    ngOnDestroy() {
        if (this.scrollSubscriber != null) {
            this.scrollSubscriber.unsubscribe();
        }
    }

    toggleViewAsList(value) {
        this.viewAsList = value;
        localStorage.setItem("viewAsList", value);
        if (this.viewAsList == 3) {
            if (document.getElementById('Ui123456') != null) {
                document.getElementById('Ui123456').className = 'app-content2';
            }
            if (document.getElementById('Ui12345') != null) {
                document.getElementById('Ui12345').className = 'app-content2';
            }
            if (this.scrollSubscriber != null) {
                this.scrollSubscriber.unsubscribe();
                this.scrollSubscriber = null;
            }
        }
        if(this.viewAsList != 3) {
            if (document.getElementById('Ui123456') != null) {
                document.getElementById('Ui123456').className = 'app-content';
            }
            if (document.getElementById('Ui12345') != null) {
                document.getElementById('Ui12345').className = 'app-content';
            }
            if (this.scrollSubscriber == null) {
                this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) =>  this.getPlaylists());
            }
        }
    }

    mouseHovering(index) {
        this.playlists[index].isHovering = true;
    }

    mouseLeaving(index) {
        this.playlists[index].isHovering = false;
    }

    // to check if playlist exist in local storage or not
    checkLocalStorage(playlist) {
        var localPlaylists = [];
        localPlaylists = this.localStoragePlaylists.filter(x => x.slug == playlist.slug);
        if(localPlaylists.length == 0) {
            this.localStoragePlaylists.push(playlist);
            // storing the playlist in local storage to avoid extra API calls
            localStorage.setItem("playlistDetail" , JSON.stringify(this.localStoragePlaylists));
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/playlists/playlists.component.ts